export enum DocSubTypeEnum {
    NONE = "NONE",
    GA = "GA",
    SUPPORT = "SUPPORT",
    FINDING = "FINDING",
    REV = "REV",
    REV0 = "REV0",
    LT_END_COMPLI = "LT_END_COMPLI",
    LT_PROV_FIND = "LT_PROV_FIND",
}